import  { ActionType } from "./../resources/constants"

const { SET_USER, SET_META, SET_ACCESS_TOKEN } = ActionType

export default function GlobalReducer(state: any, action: { type: string, payload?: any }) {
    switch (action.type) {
        case SET_USER:
            return setUser(state,action);
        case SET_META:
            return setMeta(state,action);
        case SET_ACCESS_TOKEN:
            return setAccessToken(state,action);
        default:
            return state;
    }
}

const setUser = (state: any, action: { type: string, payload?: any } ) => {
    const { user } = action.payload;

    return {
        ...state,
        user
    }
}

const setMeta = (state: any, action: { type: string, payload?: any } ) => {
    const { meta } = action.payload;

    return {
        ...state,
        meta
    }
}

const setAccessToken = (state: any, action: { type: string, payload?: any } ) => {
    const { accessToken } = action.payload;

    return {
        ...state,
        accessToken
    }
}
